import React, { useState } from 'react';
import { message, Form, Input, Button, Card, Space, Select, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { TextArea } = Input;

export default function WritePost({ onAddPost, loggedInUser, allTags = [] }) {
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [tags, setTags] = useState([]);
  const [content, setContent] = useState('');
  const [preview, setPreview] = useState(true);
  const navigate = useNavigate();

  function handleSubmit() {
    if (!loggedInUser) {
      message.error('请先登录再发表文章');
      return;
    }
    const t = title && title.trim();
    const c = content && content.trim();
    if (!t || !c) {
      message.error('标题和内容不能为空');
      return;
    }

    // 将摘要与 tags 一起传给 onAddPost（后端/本地存储可单独存储这些字段）
    const ok = onAddPost(t, summary, tags, c);
    if (ok) {
      setTitle('');
      setSummary('');
      setTags([]);
      setContent('');
      message.success('发布成功，正在返回首页');
      navigate('/');
    }
  }

  return (
    <div className="page-container">
      <h1 style={{ textAlign: 'center', fontSize: 28, marginBottom: 20 }}>撰写新文章</h1>

      <Card variant="plain" style={{ boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
        <Form layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col xs={24} lg={24}>
              <Form.Item label={<span>文章标题 <span style={{ color: '#ff4d4f' }}>*</span></span>} required>
                <Input placeholder="请输入文章标题" value={title} onChange={(e) => setTitle(e.target.value)} />
              </Form.Item>
            </Col>

            <Col xs={24} lg={24}>
              <Form.Item label={<span>文章摘要 <span style={{ color: '#ff4d4f' }}>*</span></span>} required>
                <TextArea placeholder="请输入文章摘要， 不超过200字" rows={4} maxLength={200} value={summary} onChange={(e) => setSummary(e.target.value)} />
              </Form.Item>
            </Col>

            <Col xs={24} lg={24}>
              <Form.Item label={<span>标签 <span style={{ color: '#ff4d4f' }}>*</span></span>} required>
                <Select
                  mode="tags"
                  style={{ width: '100%' }}
                  placeholder="选择或输入标签（按回车创建新标签）"
                  value={tags}
                  onChange={(v) => setTags(v)}
                  options={allTags.map((t) => ({ label: t, value: t }))}
                />
              </Form.Item>
            </Col>

            <Col xs={24} lg={24}>
              <Form.Item label={<span>文章内容 (支持Markdown语法) <span style={{ color: '#ff4d4f' }}>*</span></span>} required>
                <TextArea placeholder="请使用 Markdown 格式输入文章内容" rows={12} value={content} onChange={(e) => setContent(e.target.value)} />
              </Form.Item>
            </Col>

            <Col xs={24} lg={24}>
              <Form.Item>
                <Space>
                  <Button type="primary" htmlType="submit">发布文章</Button>
                  <Button onClick={() => setPreview((p) => !p)}>{preview ? '隐藏预览' : '显示预览'}</Button>
                  <Button onClick={() => { setTitle(''); setSummary(''); setTags([]); setContent(''); }}>清空</Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {preview && (
          <Card size="small" title="预览" style={{ marginTop: 12 }}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content || '*空内容*'}</ReactMarkdown>
          </Card>
        )}
      </Card>
    </div>
  );
}
